(function () {
  'use strict';

  var modal, overlay, closeBtn, content, i18n, cfg;
  var activeHandle = null;
  var currentProduct = null;
  var selectedOpts = [];
  var triggerEl = null;

  // -- Escape helpers --------------------------------------------
  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function stripHTML(html) {
    return html.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
  }

  // -- Money -----------------------------------------------------
  var locale = document.documentElement.lang || 'en';
  var currencyCode =
    window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'USD';
  var moneyFmt = new Intl.NumberFormat(locale, { style: 'currency', currency: currencyCode });
  function money(cents) {
    return moneyFmt.format(cents / 100);
  }

  // -- Image helpers ---------------------------------------------
  // Shopify AJAX API returns images as strings OR objects with .src
  function imgSrc(img) {
    if (!img) return '';
    return typeof img === 'string' ? img : (img.src || '');
  }

  function resizeImg(src, size) {
    if (!src) return '';
    return src.replace(/(\.[a-zA-Z]{2,5})(\?|$)/, '_' + size + '$1$2');
  }

  // -- Option helpers --------------------------------------------
  // Shopify AJAX API returns options as strings OR objects {name, values}
  function optName(opt) {
    return typeof opt === 'string' ? opt : (opt && opt.name ? opt.name : '');
  }

  function optValues(opt, product, i) {
    // If object format has .values array, use that (preserves order)
    if (opt && Array.isArray(opt.values)) return opt.values;
    // Otherwise derive unique values from variants
    var seen = [];
    product.variants.forEach(function (v) {
      var val = v['option' + (i + 1)];
      if (val && seen.indexOf(val) < 0) seen.push(val);
    });
    return seen;
  }

  // -- Variant matching ------------------------------------------
  function findVariant(product) {
    return (
      product.variants.find(function (v) {
        return product.options.every(function (_, i) {
          return v['option' + (i + 1)] === selectedOpts[i];
        });
      }) || product.variants[0]
    );
  }

  // -- Price HTML ------------------------------------------------
  function priceHTML(variant) {
    if (variant.compare_at_price > variant.price) {
      var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
      return (
        '<span class="qv-price qv-price--sale">' + money(variant.price) + '</span>' +
        '<s class="qv-compare">' + money(variant.compare_at_price) + '</s>' +
        '<span class="qv-sale-pct">-' + pct + '%</span>'
      );
    }
    return '<span class="qv-price">' + money(variant.price) + '</span>';
  }

  // -- Gallery HTML ----------------------------------------------
  function galleryHTML(product) {
    var images = product.images || [];
    var firstSrc = images.length > 0 ? imgSrc(images[0]) : imgSrc(product.featured_image);
    var mainSrc = resizeImg(firstSrc, '640x640') || firstSrc;

    var mainHTML =
      '<div class="qv-main-img-wrap">' +
      (mainSrc
        ? '<img id="qv-main-img" src="' + esc(mainSrc) + '" alt="' + esc(product.title) + '" class="qv-img" width="640" height="640" loading="eager">'
        : '') +
      '</div>';

    var thumbsHTML = '';
    if (cfg.showGallery && images.length > 1) {
      thumbsHTML =
        '<div class="qv-thumbs" role="list">' +
        images.slice(0, 7).map(function (img, i) {
          var src = imgSrc(img);
          var fullSrc = resizeImg(src, '640x640') || src;
          var thumbSrc = resizeImg(src, '120x120') || src;
          return (
            '<button type="button" class="qv-thumb' + (i === 0 ? ' is-active' : '') + '" role="listitem"' +
            ' data-full="' + esc(fullSrc) + '"' +
            ' aria-label="Image ' + (i + 1) + '">' +
            '<img src="' + esc(thumbSrc) + '" alt="" width="60" height="60" loading="' + (i < 3 ? 'eager' : 'lazy') + '">' +
            '</button>'
          );
        }).join('') +
        '</div>';
    }

    return mainHTML + thumbsHTML;
  }

  // -- Tags HTML -------------------------------------------------
  function tagsHTML(product) {
    var tags = (product.tags || [])
      .filter(function (t) {
        return t.indexOf(':') < 0   // internal key:value tags
          && t.indexOf('$') < 0     // price range tags
          && t.indexOf(' - ') < 0   // range tags like "400 - 500"
          && !/^\d/.test(t)         // tags starting with a number
          && t.length >= 3
          && t.length < 28;
      })
      .slice(0, 6);
    if (!tags.length) return '';
    return (
      '<div class="qv-tags">' +
      tags.map(function (t) { return '<span class="qv-tag">' + esc(t) + '</span>'; }).join('') +
      '</div>'
    );
  }

  // -- Description HTML ------------------------------------------
  function descHTML(product) {
    if (!product.description) return '';
    var plain = stripHTML(product.description);
    if (!plain) return '';
    var short = plain.length > 160 ? plain.slice(0, 158) + '…' : plain;
    return '<p class="qv-desc">' + esc(short) + '</p>';
  }

  // -- Stock HTML ------------------------------------------------
  function stockHTML(variant) {
    if (!variant.available) {
      return '<p class="qv-stock qv-stock--out"><span class="qv-stock__dot"></span>' + esc(i18n.soldOut) + '</p>';
    }
    return '<p class="qv-stock qv-stock--in"><span class="qv-stock__dot"></span>' + esc(i18n.inStock) + '</p>';
  }

  // -- Options HTML ----------------------------------------------
  function optionsHTML(product) {
    var firstName = optName(product.options[0]);
    if (product.options.length === 1 && (firstName === 'Title' || firstName === '')) return '';
    return product.options.map(function (opt, i) {
      var name = optName(opt);
      var vals = optValues(opt, product, i);
      var pills = vals.map(function (val) {
        var isSel = selectedOpts[i] === val;
        var isAvail = product.variants.some(function (v) { return v['option' + (i + 1)] === val && v.available; });
        return (
          '<button type="button" class="qv-pill' +
          (isSel ? ' is-selected' : '') +
          (isAvail ? '' : ' is-unavailable') +
          '" data-oi="' + i + '" data-ov="' + esc(val) + '">' +
          esc(val) +
          '</button>'
        );
      }).join('');
      return (
        '<div class="qv-option">' +
        '<p class="qv-option__label">' + esc(name) + ': <strong class="qv-option__selected" data-od="' + i + '">' + esc(selectedOpts[i] || vals[0]) + '</strong></p>' +
        '<div class="qv-pills">' + pills + '</div>' +
        '</div>'
      );
    }).join('');
  }

  // -- Full build ------------------------------------------------
  function buildHTML(product) {
    var variant = findVariant(product);
    var salePct = variant.compare_at_price > variant.price
      ? Math.round((1 - variant.price / variant.compare_at_price) * 100)
      : 0;

    var opts = optionsHTML(product);
    var atcLabel = variant.available ? i18n.addToCart : i18n.soldOut;

    return (
      '<div class="qv-layout">' +

      /* -- LEFT: gallery -- */
      '<div class="qv-media">' +
      (salePct > 0 ? '<span class="qv-badge">-' + salePct + '%</span>' : '') +
      galleryHTML(product) +
      '</div>' +

      /* -- RIGHT: info -- */
      '<div class="qv-info">' +

      (cfg.showVendor && product.vendor ? '<p class="qv-vendor">' + esc(product.vendor) + '</p>' : '') +
      '<h2 class="qv-title">' + esc(product.title) + '</h2>' +

      '<div class="qv-price-row" data-qv-price>' + priceHTML(variant) + '</div>' +

      (cfg.showStock ? stockHTML(variant) : '') +
      (cfg.showTags ? (tagsHTML(product) || '') : '') +
      (cfg.showDescription ? (descHTML(product) || '') : '') +

      (opts ? '<div class="qv-options">' + opts + '</div>' : '') +

      '<div class="qv-actions">' +
      (cfg.showQuantity
        ? '<div class="qv-qty-wrap">' +
          '<button type="button" class="qv-qty-btn" data-dec aria-label="Decrease">−</button>' +
          '<input type="number" class="qv-qty" value="1" min="1" aria-label="Quantity">' +
          '<button type="button" class="qv-qty-btn" data-inc aria-label="Increase">+</button>' +
          '</div>'
        : '') +
      '<button type="button" class="qv-atc' + (!variant.available ? ' is-unavailable' : '') + '" data-qv-atc data-vid="' + variant.id + '"' + (!variant.available ? ' disabled' : '') + '>' +
      atcLabel +
      '</button>' +
      '</div>' +

      '<a href="/products/' + esc(product.handle) + '" class="qv-full-link">' + esc(i18n.viewDetails) + '</a>' +

      '</div>' + /* qv-info */
      '</div>'   /* qv-layout */
    );
  }

  // -- Sync price + pills after variant change -------------------
  function syncVariant(product) {
    var variant = findVariant(product);
    if (!variant) return;

    var priceRow = content.querySelector('[data-qv-price]');
    if (priceRow) priceRow.innerHTML = priceHTML(variant);

    var stockEl = content.querySelector('.qv-stock');
    if (stockEl) stockEl.outerHTML = stockHTML(variant);

    var atcBtn = content.querySelector('[data-qv-atc]');
    if (atcBtn) {
      atcBtn.dataset.vid = variant.id;
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? i18n.addToCart : i18n.soldOut;
      atcBtn.classList.toggle('is-unavailable', !variant.available);
    }

    content.querySelectorAll('.qv-pill').forEach(function (pill) {
      var oi = parseInt(pill.dataset.oi, 10);
      pill.classList.toggle('is-selected', pill.dataset.ov === selectedOpts[oi]);
    });

    content.querySelectorAll('[data-od]').forEach(function (el) {
      el.textContent = selectedOpts[parseInt(el.dataset.od, 10)];
    });
  }

  // -- Wire up interactions --------------------------------------
  function initContent(product) {
    // Gallery thumbnails
    var mainImg = content.querySelector('#qv-main-img');
    content.querySelectorAll('.qv-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg || thumb.classList.contains('is-active')) return;

        content.querySelectorAll('.qv-thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');

        var newSrc = thumb.dataset.full;
        mainImg.style.opacity = '0';

        // Preload: opacity = 1 only after image has loaded, not after a fixed delay
        var preload = new Image();
        preload.onload = function () {
          mainImg.src = newSrc;
          mainImg.style.opacity = '1';
        };
        preload.onerror = function () {
          mainImg.src = newSrc;
          mainImg.style.opacity = '1';
        };
        preload.src = newSrc;
      });
    });

    // Variant pills
    content.querySelectorAll('.qv-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var oi = parseInt(pill.dataset.oi, 10);
        selectedOpts[oi] = pill.dataset.ov;

        if (!findVariant(product)) {
          var fallback = product.variants.find(function (v) {
            return v['option' + (oi + 1)] === selectedOpts[oi];
          });
          if (fallback) {
            product.options.forEach(function (_, i) {
              selectedOpts[i] = fallback['option' + (i + 1)];
            });
          }
        }
        syncVariant(product);
      });
    });

    // Quantity
    var qtyInput = content.querySelector('.qv-qty');
    var decBtn = content.querySelector('[data-dec]');
    var incBtn = content.querySelector('[data-inc]');
    if (decBtn) decBtn.addEventListener('click', function () {
      var v = parseInt(qtyInput.value) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    if (incBtn) incBtn.addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
    });

    // ATC
    content.querySelector('[data-qv-atc]').addEventListener('click', function () {
      var btn = this;
      if (btn.disabled) return;
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      var origText = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';

      function onSuccess() {
        btn.textContent = i18n.added;
        btn.classList.add('is-added');
        setTimeout(function () {
          btn.textContent = origText;
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1800);
      }

      function onError() {
        btn.textContent = origText;
        btn.disabled = false;
      }

      if (window.MarketlyCart) {
        window.MarketlyCart.add(parseInt(btn.dataset.vid), qty)
          .then(onSuccess)
          .catch(onError);
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: parseInt(btn.dataset.vid), quantity: qty }),
        })
          .then(function (r) { return r.ok ? onSuccess() : onError(); })
          .catch(onError);
      }
    });
  }

  // -- Modal animation -------------------------------------------
  function openModal() {
    modal.hidden = false;
    var scrollY = window.scrollY;
    document.body.dataset.qvScrollY = scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
    });
  }

  function closeModal() {
    modal.classList.remove('is-open');
    var scrollY = parseInt(document.body.dataset.qvScrollY || '0', 10);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
    var returnFocus = triggerEl;
    modal.addEventListener('transitionend', function handler() {
      modal.removeEventListener('transitionend', handler);
      modal.hidden = true;
      activeHandle = null;
      currentProduct = null;
      triggerEl = null;
      if (returnFocus) returnFocus.focus({ preventScroll: true });
    }, { once: true });
  }

  // -- Fetch & render --------------------------------------------
  async function trigger(handle, qty) {
    if (handle === activeHandle && !modal.hidden) return;
    activeHandle = handle;
    openModal();
    content.innerHTML = '<div class="qv-spinner"><span></span><span></span><span></span></div>';

    try {
      var res = await fetch('/products/' + handle + '.js');
      if (!res.ok) throw new Error();
      currentProduct = await res.json();

      selectedOpts = currentProduct.options.map(function (_, i) {
        return currentProduct.variants[0]['option' + (i + 1)];
      });

      content.innerHTML = buildHTML(currentProduct);
      initContent(currentProduct);

      if (qty && qty > 1) {
        var qtyInput = content.querySelector('.qv-qty');
        if (qtyInput) qtyInput.value = qty;
      }
    } catch (_) {
      content.innerHTML =
        '<p style="padding:3rem 2rem;text-align:center;color:var(--color-text-muted,#657066)">Could not load product details.</p>';
    }
  }

  // -- Focus trap ------------------------------------------------
  function trapFocus(e) {
    if (!modal || modal.hidden) return;
    var focusable = Array.from(modal.querySelectorAll(
      'button:not([disabled]),[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'
    ));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
  }

  // -- Bootstrap -------------------------------------------------
  function init() {
    modal = document.getElementById('qv-modal');
    if (!modal) return;

    overlay  = document.getElementById('qv-overlay');
    closeBtn = document.getElementById('qv-close');
    content  = document.getElementById('qv-content');

    i18n = {
      addToCart:   modal.dataset.i18nAtc     || 'Add to cart',
      added:       modal.dataset.i18nAdded   || 'Added!',
      soldOut:     modal.dataset.i18nSoldOut || 'Sold out',
      inStock:     modal.dataset.i18nInStock || 'In stock',
      viewDetails: modal.dataset.i18nView    || 'View full details →',
    };

    cfg = {
      showGallery:     modal.dataset.cfgGallery     !== 'false',
      showVendor:      modal.dataset.cfgVendor       !== 'false',
      showStock:       modal.dataset.cfgStock        !== 'false',
      showTags:        modal.dataset.cfgTags         !== 'false',
      showDescription: modal.dataset.cfgDescription  !== 'false',
      showQuantity:    modal.dataset.cfgQuantity      !== 'false',
    };

    overlay.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
      trapFocus(e);
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-view]');
      if (btn) {
        triggerEl = btn;
        trigger(btn.dataset.quickView, parseInt(btn.dataset.quickViewQty || '1', 10));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
